<template>
    <div>
        <!-- Display state if user is not yet paid -->
        <md-empty-state
            v-cloak
            v-if="isWaitingPayment && userDetails.paymentConfirm == false &&
            (userDetails.research_talent_repondu == '' || userDetails.research_talent_repondu == null) && !loadingUser"
            v-show="pay_success == false"
            class="md-accent"
            md-icon="error_outline"
            :md-label="$t('payment_not_received')"
            :md-description="$t('payment_not_received_text_label')">
            <button @click="payment_url" class="btn-rounded btn btn-info btn-sm ripple-parent">Continue to online payment</button>
        </md-empty-state>
        <!-- Display state if user is not yet pconfirm payment -->
        <md-empty-state
            v-cloak
            v-else-if="isWaitingPayment && userDetails.paymentConfirm == true &&
            (userDetails.research_talent_repondu == '' || userDetails.research_talent_repondu == null) && !loadingUser"
            v-show="pay_success == false"
            class="md-accent"
            md-icon="error_outline"
            :md-label="$t('payment_not_confirm')"
            :md-description="$t('payment_not_confirm_text_label')">
            <button @click="reload_url" class="btn-rounded btn btn-info btn-sm ripple-parent">Recommencer</button>
        </md-empty-state>
        <!-- Display state if user haven't selected his/her gender or civilty -->
        <md-empty-state
            v-cloak
            v-else-if="(userDetails.civility == '' || userDetails.civility == null) && !loadingUser"
            v-show="pay_success == false"
            class="md-accent"
            md-icon="error_outline"
            :md-label="$t('civility_not_selected')"
            :md-description="$t('civility_not_selected_text_label')">
            <localized-link to="account">{{$t('link_account_settings')}}</localized-link>
        </md-empty-state>
        <!-- Display state if user responded the talents research questionnaire -->
        <md-empty-state
            v-cloak
            v-else-if="parseInt(userDetails.research_talent_repondu) > talentsTotalQuestions && talentsSuccessMessage == false"
            class="md-primary" md-icon="thumb_up"
            :md-label="$t('nothing_to_be_done')"
            :md-description="$t('nothing_to_be_done_text_label')">
        </md-empty-state>
        <!-- Display questionnaire with questions if user have been paid -->
        <div class="questionnaire-wrapper" v-else v-show="(submitted == false && talentMessage == false) || isAnswered == true" v-cloak>
            <breadcrumb v-show="!loading">{{$t('viewing')}}&nbsp;&nbsp;
                <breadcrumb-item><a>{{currentPage}}</a></breadcrumb-item>
                <breadcrumb-item active>{{totalPages}}</breadcrumb-item>
            </breadcrumb>
            <div class="loading-spinner-wrap" v-if="loading">
                <md-progress-spinner :md-stroke="4" md-mode="indeterminate"></md-progress-spinner>
            </div>
            <div v-for="(question,i) in arr_questions" :key="i">
                <div class="theme-libelle" v-for="(theme,index) in question.theme" :key="index" v-if="theme.locale === currentLocale">
                    {{ theme.libelle }}
                </div>
                <div class="questionnaire-item d-flex align-items-center justify-content-between" v-for="q in question.questions" :key="q.id">
                    <div class="question-item d-flex align-items-center col-xl-8 col-lg-7 col-md-6 col-sm-5">
                        <span class="index-number">{{ q.order }}</span>
                        <p v-for="(locales,index) in q.translations" :key="index" v-if="locales.locale === currentLocale">
                            <span v-if="userDetails.civility == 'Monsieur'">{{ locales.libelle_masculin }}</span>
                            <span v-else-if="userDetails.civility == 'Madame'">{{ locales.libelle_feminin == '' ? locales.libelle_masculin : locales.libelle_feminin }}</span>
                            <span v-else>Please select preferred civility to display questions</span>
                        </p>
                    </div>
                    <choices class="col-xl-4 col-lg-5 col-md-6 col-sm-7" :response="q" :order="q.order" @counter="count" @status="state" :currentLocale="currentLocale" :ifResearchQuestionnaire="isAnswered" :isTestQuestionnaire="false" :civility="userDetails.civility" />
                </div>
            </div>
            <br>
            <button v-show="!loading && page != totalPages && totalAnswered == currentLength" :disabled="page >= totalPages" @click="nextPage" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('next')}}</button>
            <button v-show="page == totalPages && totalAnswered == currentLength" @click="submitAnswers" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('submit_answers')}}</button>
        </div>
        <!-- Display state if user paid the bill successfully -->
        <md-empty-state
            v-if="pay_success == true"
            class="md-primary" md-icon="done"
            :md-label="$t('payment_sent')"
            :md-description="$t('payment_sent_text_label')">
            <button @click="questionnaire_instructions" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('continue_to_questionnaire')}}</button>
        </md-empty-state>
        <!-- Display state if user answered the talents research questionnaire successfully -->
        <md-empty-state
            v-if="submitted == true && talentsSuccessMessage == true"
            class="md-primary" md-icon="done"
            :md-label="$t('your_answers_have_been_saved_talent')"><br>
            <a :href="`https://www.comcolors.com/${currentLocale}/quest-ce-que-le-modele-comcolors`" target="_blank"><button class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('return_to_home')}}</button></a>
        </md-empty-state>
    </div>
</template>

<script>
import axios from 'axios'
import { Breadcrumb, BreadcrumbItem } from 'mdbvue'
import Choices from '@/components/Question'
import { QUESTIONNAIRE_API, BASE_API } from '../helpers/base'
import LocalizedLink from '@/components/Menu';
import { getLoggedUser, isTalentApp, getBillTalent, getBillColor } from '../services/User.service'
import { postResearchRespondDate, getResearchQuestionResponse } from '../services/Questionnaire.service'
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'
import VueStripeCheckout from 'vue-stripe-checkout'

const options = {
    key: process.env.STRIPE_KEY,
    image: 'https://www.comcolors.com/public/images/Bleu-bleu.jpg',
    locale: 'auto',
    currency: 'EUR',
    billingAddress: true,
    panelLabel: 'Pay {{amount}}'
}
Vue.use(VueStripeCheckout, options);

export default {
    name: 'TalentQuestionnaire',
    components: { Choices, Breadcrumb, BreadcrumbItem, LocalizedLink },
    data(){
        return {
            questions: [],
            questionnaireId: 17,
            loading: false,
            loadingUser: true,
            page: 1,
            currentPage: 0,
            totalPages: 0,
            perPages: 10,
            totalAnswered: 0,
            active: false,
            submitted: false,
            pay_success: false,
            userDetails: {
                email: '',
                password: '',
                paye: '',
                talent_paye: '',
                repondu: '',
                type_client: '',
                totalBill: 0,
                civility: '',
                elearningStress: '',
                elearningEnsemble: '',
                research_talent_repondu: '',
                paymentConfirm: false
            },
            isAnswered: false,
            hasSubmitAnsweredProfile: false,
            talentMessage: false,
            submitTalentsAnswer: false,
            talentsSuccessMessage: false,
            talentsTotalQuestions: 121
        };
    },
    methods:{
        ...mapActions(['setUserDetails']),
        async getQuestions() {
            this.loading = true;
            this.totalAnswered = 0
            try {
                let apiUse = `${QUESTIONNAIRE_API}/questionnaire/${this.questionnaireId}/questions/${this.currentUser.civilite}?page=${this.page}`;
                if (this.questionnaireId == 6) {
                  apiUse = `${BASE_API}/questionnaire/${this.questionnaireId}/questions/${this.currentUser.civilite}?page=${this.page}`;
                }
                let response = await fetch(apiUse);
                let json = await response.json();
                this.currentPage = json.questions.current_page;
                this.totalPages = json.questions.last_page;
                this.perPages = json.questions.per_page;
                this.questions = json.questions.data;
                this.loading = false;
            }
            catch(err) {
            }
        },
        getTalentQuestions(){
            this.totalAnswered = 0;
            this.submitted = false;
            this.talentMessage = false;
            this.isAnswered = true;
            this.submitTalentsAnswer = true;
            this.getQuestions();
        },
        submitAnswers(){
            this.loading = true;
            this.isAnswered = false;

            if(this.submitTalentsAnswer == true){
                //Submit talents research date answered
                this.talentMessage = true;
                this.isAnswered = false;
                this.talentsSuccessMessage = true;
                this.submitted = true;
                this.loading = false;
                let data = {
                    userId: localStorage.getItem('userId'),
                    isResearchQuestionnaireEnabled: true
                }
                postResearchRespondDate(data).then(resp => {
                    this.userDetails.research_talent_repondu = resp.data.date_answered;
                    //this.hasSubmitAnsweredProfile = true;
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        nextPage(){
            this.totalAnswered = 0;
            this.page++;
            this.backToTop();
            this.getQuestions();
            if(this.isAnswered == true){
                this.totalAnswered = 0;
                this.getTalentQuestions();
            }
        },
        count(value){
            if(this.totalAnswered != this.currentLength){
                this.totalAnswered += value;
            }
        },
        state(stat){
            this.active = stat;
            if(this.talentMessage == true){
                this.totalAnswered = 0
            }
        },
        getUserData(){
            if(localStorage.getItem('userId')) {
                this.loadingUser = true;
                const userId = localStorage.getItem('userId');
                getLoggedUser(userId).then(response => {
                    const userData = response.data.user_info
                    this.setUserDetails(userData);
                    this.userDetails.email = userData.email
                    this.userDetails.repondu = userData.questionnaire_repondu.repondu
                    this.userDetails.paye = userData.paye
                    this.userDetails.talent_paye = userData.talent_payement_date
                    this.userDetails.type_client = userData.relation_groupe.type_client
                    this.userDetails.totalBill = this.getTotalBill(userData)
                    this.userDetails.civility = userData.civilite
                    this.userDetails.elearningStress = userData.questionnaire_repondu.elearningstress
                    this.userDetails.elearningEnsemble = userData.questionnaire_repondu.elearningensemble
                    this.userDetails.research_talent_repondu = userData.research_respond_date
                    this.userDetails.paymentConfirm = userData.payment_confirm
                    console.log('UserData TalentQuestionnaire: ', userData)
                    this.loadingUser = false;
                }).catch(error => {
                    console.log(error.response);
                    this.loadingUser = false;
                })
            }
        },
        backToTop(){
            $('html,body').stop().animate({
                scrollTop: 0
            }, 'slow', 'swing');
        },
        payment_url(){
            this.$router.push({name:'Payment'});
        },
        reload_url(){
            this.$router.push({name:'QuestionnaireInstructions'});
        },
        questionnaire_instructions(){
            this.$router.push({name:'QuestionnaireInstructions'});
        },
        async getUnAnsweredQuestions(){
            const userId = localStorage.getItem('userId');
            let currentPage = 0
            this.totalAnswered = 0

            getResearchQuestionResponse(userId).then(resp => {
                localStorage.setItem('talent_answers_'+userId, JSON.stringify(resp.data.answers));
                const user_answer = resp.data.answers;
                const totalAnswered = user_answer.length
                if(currentPage >= this.totalPages){
                    currentPage = parseInt(totalAnswered / this.perPages)
                }else{
                    currentPage = parseInt(totalAnswered / this.perPages) + 1
                }
                if(currentPage !== this.page){
                    this.page = currentPage
                    this.totalAnswered = 0
                    this.getQuestions();
                }
                console.log("Current page getResearchQuestionResponse: ", currentPage);
            }).catch(error => {
                console.log(error);
            });
        },
      getTotalBill(userInfo){
        let totalAmount = 0;
        // je suis dans l'application talents
        if (isTalentApp()) {
          totalAmount = getBillTalent(userInfo)
          // je suis dans l'application couleurs
        } else {
          totalAmount = getBillColor(userInfo)
        }
        return totalAmount;
      }
    },
    computed:{
        ...mapGetters(['currentUser']),
        currentLocale() {
            return this.$route.params.locale
        },
        currentLength(){
            const obj = Object.keys(this.questions)
            return obj.length;
        },
        arr_questions(){
            let data = this.questions
            const grouped = _(data)
            .groupBy(x => x.group.libelle)
            .map((value, index) => ({
                theme: value[0].group.translations,
                questions: value
            }))
            .value();
            console.log("Result: ", grouped);
            return grouped;
        },
        isWaitingPayment(){
          let ispaid = false

            ispaid = this.userDetails.talent_paye != null ? true : false
            // Dans le cas ou le questionnaire talent est gratuit
            if (parseInt(this.userDetails.totalBill)<= 0)
              ispaid = true

          return !ispaid;
        }
    },
    watch: {
        '$route': ['getUserData']
    },
    async mounted(){
        this.getUserData();
        this.submitted = false;
        this.talentMessage = false;
        this.isAnswered = true;
        this.submitTalentsAnswer = true;
        await this.getQuestions();
        await this.getUnAnsweredQuestions();
    }
}
</script>

<style scoped>
[v-cloak] {
display: none;
}
.questionnaire-wrapper {
position: relative;
}
.questionnaire-item {
background-color: #f9f9f9;
border-bottom: 1px solid #dadada;
}
.questionnaire-item:hover {
background-color: rgba(51, 181, 229, 0.12)
}
.questionnaire-item p {
text-align: left;
margin-bottom: 0;
padding: 10px 0 10px 15px;
font-size: 16px !important;
}
.questionnaire-item span.index-number {
background: #33b5e5;
color: #fff;
padding: 3px 10px 3px 10px;
}
.loading-spinner-wrap {
position: fixed;
width: 100%;
left: 0;
right: 0;
top: 0;
bottom: 0;
background-color: rgba(255,255,255,0.7);
z-index: 99999;
}
.loading-spinner-wrap .md-progress-spinner {
height: 100%;
justify-content: center;
align-items: center;
}
.questionnaire-wrapper ol.breadcrumb {
background-color: #eaeaea;
justify-content: flex-end;
font-weight: 600;
}
.answered {
border-right: 3px solid #33b5e5
}
.theme-libelle {
padding: 25px 15px 25px 15px;
background: #eaeaea;
font-weight: 600;
text-align: center;
font-size: 4vmin !important;
border: 2px solid black;
}
.md-empty-state {
padding: 0;
}
.hr-text {
line-height: 1em;
position: relative;
outline: 0;
border: 0;
color: black;
text-align: center;
height: 1.5em;
opacity: .5;
}
.hr-text:before {
content: '';
background: linear-gradient(to right, transparent, #818078, transparent);
position: absolute;
left: 0;
top: 50%;
width: 100%;
height: 1px;
}
.hr-text:after {
content: attr(data-content);
position: relative;
display: inline-block;
color: black;
padding: 0 .5em;
line-height: 1.5em;
color: #818078;
background-color: #fcfcfa;
}
@media (max-width: 580px){
.questionnaire-item {
flex-direction: column;
}
.question-item p {
text-align: justify;
}
.question-item,
.choices-wrap {
-ms-flex: 0 0 100%;
-webkit-box-flex: 0;
flex: 0 0 100%;
max-width: 100%;
}
}
@media (max-width: 420px) {
  .theme-libelle {
    font-size: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TalentQuestionnaire.vue